<template>
  <div class="page-dialog">
    <el-form
      label-width="90px"
      label-position="right"
      :inline="true"
      size="small"
    >
      <el-row>
        <el-col :span="8">
          <el-form-item label="联系人">
            <el-input v-model="conditions.c_o_name" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="联系人电话">
            <el-input v-model="conditions.tel_number" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="收货地址">
            <el-input v-model="conditions.street" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="btky-tr">
        <el-button type="default" size="small" icon="el-icon-refresh-right" @click="resetQuery">重置</el-button>
        <el-button type="primary" size="small" :loading="loading" icon="el-icon-search" @click="queryData">查询</el-button>
      </el-row>
    </el-form>
    <div class="table-container">
      <TableCommon
        :custome-config="() => vxeShowCustom('gridOptions')"
        :show-header="false"
      >
        <vxe-grid
          ref="gridOptions"
          v-loading="loading"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="300"
          align="center"
          size="medium"
          :checkbox-config="{ highlight: true }"
          :radio-config="{ highlight: true }"
          empty-text="暂时没数据"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
          @cell-dblclick="cellClick"
        />
      </TableCommon>
    </div>
  </div>
</template>

<script>
import { getCutAddress } from '@/api/sap/client-sap'
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'

// 接口入口
export default {
  props: {
    partner: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showDialogType: '',
      showDialog: false,
      dialogTitle: '',
      selectDataOptions: {},
      conditions: {
        c_o_name: '',
        street: '',
        tel_number: ''
      },
      loading: false,
      gridOptions: {
        columns: [
          { type: 'radio', title: '', filed: 'radio', width: 50 },
          {
            field: 'PARTNER',
            title: '收货方单位编号'
          },
          {
            field: 'PARTNER_NAME',
            title: '收货方单位名称'
          },
          {
            field: 'C_O_NAME',
            title: '联系人'
          },
          {
            field: 'TEL_NUMBER',
            title: '联系电话'
          },
          {
            field: 'STREET',
            title: '收货地址'
          }
        ],
        data: []
      }
    }
  },
  computed: {},
  methods: {
    cellClick({ row }) {
      this.$refs.gridOptions.setRadioRow(row)
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    },
    // 查询
    async queryData() {
      this.loading = true
      const tmp = {
        'sign': 'I',
        'option': 'CP',
        'low': '',
        'high': ''
      }
      const params = { partner: this.partner }
      for (const key in this.conditions) {
        if (this.conditions[key]) {
          params[key] = [{
            ...tmp,
            low: '*' + this.conditions[key] + '*'
          }]
        }
      }
      try {
        const res = await getCutAddress(params)
        this.gridOptions.data = res.DATA
      } catch (e) {
        //
      }
      this.loading = false
    },
    // 处理分页事件table
    handleTablePaginationChange(pageParams) {
      this.pagination = { ...this.pagination, ...pageParams }
      this.queryData()
    },
    resetQuery() {
      this.conditions = {
        customerName: '',
        linkman: ''
      }
    },
    // 用于弹窗提交时 回调数据
    submitForm() {
      // 给父组件返回promise对象用于回调
      return new Promise(resolve => {
        const selectData = this.$refs.gridOptions.getRadioRecord()
        resolve(selectData)
      })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/dialog/CommonAddress.vue